<div class="d-flex container">
	<div class="row pt-0">
		<mat-icon [ngClass]="theme">circle</mat-icon>
		<label class="statusLabel pl-3" [ngClass]="theme">{{ labelText }}</label>
	</div>
</div>
